export default {

  home: {
    title: '首页',
    login: '登录'
  },
  orderTabs: {
    all: '全部',
    refund: '退款'
  },
  payment: {
    returnAndComplete: '请返回支付宝小程序，点击完成支付',
      processing: '支付处理中，请稍候...',
  processingTimeout: '支付超时，请稍后再试',
  getPaymentInfoFailed: '支付失败，请重试',
  requestFailed: '请求失败，请重试'
},
  common: {
     captchaError: '图形验证码错误',
      useConsumerVoucher: '使用消费券',
  showVoucherToStaff: '请向店员出示电子凭证',
  scanToRedeem: '请使用「商户通」扫描核销此券',
      coupon_expired:"该券码已失效，请重新扫码",
    scan_again:"重新扫码",
        strfa:"滚动查看完整协议",
    coupon_already_claimed:"该券码已被领取，请重新扫码",
    all: '全部',
    cancel: '取消',
    confirm: '确认',
    prompt: '提示',
    loading: '正在加载',
    loadFailed: '加载失败',
    loginSuccess: '登录成功',
    loggingIn: '正在登录',
    pleaseLogin: '请先登录',
    noContent: '这里还没有内容哟~',
    loadMore: '正在加载更多...',
    loadedAll: '已经全部加载完毕',
    noMore: '没有更多了~',
    missingParam: '缺少参数',
    pendingConfirm: '待确认',
    pendingPay: '待支付',
    completed: '已完成',
    refunded: '已退款',
    processing: '处理中',
    refunding: '退款中',
    pendingDelivery: '待发货',
    pendingVerification: '待核销',
    verified: '已核销',
    expired: '已过期',
    partialRefund: '部分退款',
    used: '已使用',
    myOrders: '我的订单',
    myCoupons: '我的消费券',
    pageOpenFailed: '页面打开失败',
    viewOrder: '查看订单',
    paySuccess: '支付成功',
    more: '更多',
    collapse: '收起',
    notSupportedYet: '暂不支持，敬请期待~',
    mr: '先生',
    ms: '女士'
  },
  auth: {
    welcomeTitle: '发现澳门欢迎你',
    welcomeDesc: '授权登录后请放心使用',
    welcomeDescProtected: '您的信息将受到保护',
    authorizeLogin: '授权登录',
    authorizationSuccess: '授权成功',
    agreementTitle: '用户协议',
    agreementConfirmText: '我已阅读并同意',
    agreementScrollTip: '请先滑动到底部',
    login: {
      appTitle: '发现澳门FindMacau',
      phoneRegister: '手机注册',
      phoneLogin: '手机登录',
      emailRegister: '邮箱注册',
      emailLogin: '邮箱登录',
      placeholderPhone: '请输入手机号码',
      placeholderEmail: '请输入邮箱号码',
      placeholderPassword: '请输入密码',
      placeholderCode: '请输入验证码',
      forgetPassword: '忘记密码',
      sendCode: '发送验证码',
      resendAfterSeconds: '{count} 秒后重新发送',
      accountLogin: '帐号登录',
      codeLogin: '验证码登录',
      agreementWithApp: '我已阅读并同意发现澳门',
      termsOfUse: '《使用条款》',
      and: '和',
      privacyPolicy: '《隐私政策》',
      registerNow: '立即注册',
      retrievePassword: '找回密码',
      alreadyHaveAccount: '已有帐号？',
      noAccountYet: '还没帐号？',
      quickLogin: '快速登录',
      quickRegister: '快速注册',
      thirdPartyLogin: '第三方帐号登录',
      humanVerifyTitle: '人机验证',
      refreshCaptcha: '点击刷新验证码',
      captchaUpdateHint: '点击上图可更新验证码',
      toast: {
        phoneEmpty: '手机号码不能为空',
        phoneInvalidFormat: '请输入正确的手机号码格式',
        emailEmpty: '邮箱号码不能为空',
        emailInvalid: '请输入有效的邮箱',
        emailFillCorrectly: '请正确填写邮箱',
        mustAgreeTerms: '必须同意条款才能注册',
        passwordInvalid: '请输入有效的密码',
        passwordRule: '请输入6-18位字母数字组合的密码',
        codeInvalid4: '请输入有效的四位验证码',
        codeSentSms: '验证码发送成功，请留意短信通知',
        codeSentEmail: '验证码发送成功，请留意邮箱通知！',
        passwordUpdated: '密码修改成功,请重新登录'
      }
    }
  },
  coupon: {
    useNow: "立即使用",
     unused: '待使用',

      used: '已使用',
       paused:"暂停发券，请稍后再试",
      expired: '已失效',

      myOrders: '我的订单',
          qrCodeTitle:'消費券二维码',
      qrCodeTip:'请使用扫码工具扫描二维码',
      useMethod: "使用方法",
    todaySoldOut: '今日抢光',
    soldOut: '已抢光',
    termsOfUse: '使用条款',
    details: '详情',
    bookingWebsite: '预订网址',
    goOfficialBooking: '点我连至官网预订',
    otherRules: '活动规则',
    receiveNow: '立即领取',
    receiveSuccess: '领取成功',
    systemPrompt: '系统提示',
    confirmUseQuestion: '确定使用吗?',
    useTime: '使用时间',
    couponQrTitle: '消費券二维码',
    showQrToMerchant: '请向商家出示二维码',
    scanToVerify: '请使用「商户通」扫描核销此券',
    couponCode: '券码',
    couponDetailsLoadFailed: '消費券详情加载失败',
    exchange: '兑换',
    inputCouponCode: '请输入优惠码',
    exchangeSuccess: '兑换成功',
    couponOrCode: '消費券/优惠码',
    couponTitle: '消費券',
    qrClosed: '已关闭二维码',
    detailTitle: '消費券详情',
    scannerTip: '请将二维码放入框内',
    cameraStartFailed: '摄像头启动失败:',
    qrNotExpired: '二维码未过期',
    noCoupons: '暂无消費券',
    pendingPayment: '待付款',
    viewNow: '立即查看',
    afterSales: '售后',
    newArrival: '新到',
    noMoreCoupons: '没有更多消费券了',
    exchangeSuccess: '兑换成功'
  },
  order: {
    goodsTotal: '商品总价',
    discount: '优惠折扣',
    eVoucher: '电子凭证',
    orderNumber: '订单编号',
    paymentTime: '支付时间',
    actualPayment:"实付金额",
    contactSupport: '联系客服',
    viewCredential: '查看凭证',
    scanMerchantQr: '请扫描商家二维码',
    writeReview: '写点评',
    viewReview: '查看评论',
    orderAmount: '订单金额',
    discountCannotStack: '优惠折扣与支付立减不可叠加',
    paymentMethod: '支付方式',
    wechatPay: '微信支付',
    detail: '明细',
    total: '合计',
    pay: '支付',

    payAmount: '需支付',
    payProcessing: '处理中...',
    payTimeout: '支付超时，请重新支付',
    createOrderFailed: '下单失败',
    paymentFailed: '支付失败',
    continuePay: '继续支付',
    finishedPay: '已完成支付',
    wechatPayGuideLine1: "1.如果未打开微信客户端或未完成付款，请点击'继续支付'；",
    wechatPayGuideLine2: "2.如果已完成，请点击'已完成支付'；",
    paymentNotCompleted: '你还未完成付款，请完成后再试',
    longPressViewOrder: '长按识别查看订单',
    click: '点击',
    backHome: '返回首页',
    autoRedirectMyOrders: 's 后将自动跳转至我的订单',
    merchant: '商户',
    finish: '完成',
    paidSuccess: '付款成功',
    orderDetail: '订单详情',
    payResult: '支付结果',
    alipay: '支付宝',
    alipayMacau: '支付宝（澳门）',
    bocWechatPay:"微信支付",
    alipayBOC: '支付宝',
    mpay: 'MPay',
    bocPay: 'BOC Pay',
    creditCardPay: '信用卡支付',
    icbcEpay: '工银E支付',
    icbcCreditCardPay: '工银信用卡支付',
    taiFungPay: '丰付宝'
  },
  qrcodepay: {
    followFindMacauOfficial: '关注“发现澳门”微信公众号',
    moreExcitingAwait: '更多精彩等着您!',
    longPressScanQr: '长按识别二维码',
    follow: '关注',
    findMacau: '发现澳门',
    officialAccountDesc: '公众号，新鲜城事抢先知',
    instantDiscount: '满{base}立减￥{amount}',
    myMiniProgram: '我的小程序'
  },
  share: {
    homeTitle: '澳门旅游及活动体验预订',
    homeDesc: '一网打尽门票、餐券、酒店、上网，当地超值折扣，最低1折起！',
    couponTitle: '嘘！送你一叠澳门吃喝玩乐旅游体验预订消費券',
    couponDesc: '不多也就价值1000元+，记得先领券再出发！'
  },
  scan: {
    putQrCodeInFrame: '将二维码放入框内',
    openingCamera: '正在打开摄像头...',
    cameraErrorTitle: '无法使用摄像头',
    cameraErrorText: '无法使用摄像头',
    reopen: '重新打开',
    scanning: '正在扫描二维码...',
    closeFlash: '关闭闪光灯',
    openFlash: '打开闪光灯',
    torchNotSupported: '当前设备不支持闪光灯'
  },
   title: {
      order: '消费券订单列表',
      orderDetail: '消费券订单详情',
      payment: '提交支付',
      paySuccess: '支付成功',
      couponDetail: '消费券详情',
      couponList: '消费券列表'
    }

}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh_CN.js